export default {
  async viewContent({dispatch}, data) {
    dispatch('mixpanelTrack', ['View Content Link', data])
  },
  //admin
  async createContent({dispatch}, [title, description, url, imageUrl, createdAt]) {
    dispatch('mixpanelTrack', ['Create Content Link', {
      'Title': title,
      'Description': description,
      'Url': url,
      'Image Url': imageUrl,
      'Created At': createdAt
    }])
  },
  async editContent({dispatch}, [title, description, url, imageUrl, createdAt, id]) {
    dispatch('mixpanelTrack', ['Edit Content Link', {
      'Title': title,
      'Description': description,
      'Url': url,
      'Image Url': imageUrl,
      'Created At': createdAt,
      'Link Id': id
    }])
  },
  async deleteContent({dispatch}, id) {
    dispatch('mixpanelTrack', ['Delete Content Link', {
      'Link Id': id
    }])
  },
}
